import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  modalTitle: {
    marginBottom: '0px',
    fontSize: theme.size.lg,
    color: '#1F1F1F'
  },

  modalClose: {
    top: '16px',
    right: '12px'
  },

  title: {
    marginBottom: '5px',
    fontSize: theme.size.sm,
    color: '#8F8F8F'
  },

  root: {
    marginBottom: 16
  },

  groupContainer: {
    margin: '1.25rem 0px'
  },

  transferName: {
    fontSize: theme.size.base,

    '& strong': {}
  },

  buttonSection: {
    display: 'flex',
    justifyContent: 'flex-end'
  },

  button: {
    width: '164px',
    height: 48,
    marginLeft: 8
  },

  inputArea: {
    marginTop: 16,
    borderBottom: `1px solid #C6C6C6`,
    cursor: 'text',
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',

    '&:focus-within': {
      borderBottomColor: 'black'
    }
  },

  agentSearchInput: {
    fontSize: theme.size.base,
    height: 17,
    border: 'none',
    outline: 'none',
    flex: 1,
    marginBottom: '8px'
  },

  chip: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '8px',
    marginRight: '5px',
    border: '1px solid #1F1F1F',
    borderRadius: '100rem',
    boxSizing: 'border-box',
    padding: '6px 12px',
    background: 'white',
    cursor: 'default',
    fontSize: theme.size.base,
    color: '#1F1F1F',

    '& label': {}
  },

  chipAvatar: {
    width: 24,
    height: 24,
    marginRight: 6
  },

  chipAction: {
    margin: '0px 4px',
    cursor: 'pointer'
  },

  searchResultContainer: {
    listStyle: 'none',
    paddingLeft: '0px',
    maxHeight: 160,
    overflowY: 'auto',

    '&::-webkit-scrollbar': {
      width: 8
    },

    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#B64FCD',
      borderRadius: 0
    }
  },

  searchResult: {
    borderRadius: '8px',
    minHeight: '52px',
    height: '52px',
    maxHeight: '52px',
    padding: '0',
    fontSize: theme.size.base,
    color: '#3C425B',
    alignItems: 'center',
    display: 'flex',
    cursor: 'pointer',

    '&:hover': {
      background: '#F5F6F8'
    }
  },

  noResult: {
    borderRadius: '8px',
    minHeight: '52px',
    height: '52px',
    maxHeight: '52px',
    padding: '0',
    fontSize: theme.size.base,
    color: 'grey',
    cursor: 'default',
    alignItems: 'center',
    display: 'flex',
    opacity: '0.7'
  },

  ReAssignLabel: {
    color: '#8F8F8F',
    fontSize: theme.size.sm,
    marginBottom: 12,
    marginTop: 12,
    cursor: 'default',
    display: 'block'
  },

  resultsContainer: {
    border: '1px solid #F0F0F0',
    borderRadius: '7px',
    boxSizing: 'border-box',
    boxShadow: '0px 20px 30px rgba(0, 0, 0, 0.16)',
    padding: '16px',
    background: 'white',

    '& > ul': {
      padding: '0'
    }
  },

  avatar: {
    width: 36,
    height: 36,
    marginRight: 12
  },

  results: {
    display: 'flex',
    flexDirection: 'column',
    maxHeight: '208px',
    overflow: 'hidden auto',

    '&::-webkit-scrollbar': {
      width: 8
    },

    '&::-webkit-scrollbar-track': {
      backgroundColor: '#E5E5E5'
    },

    '&::-webkit-scrollbar-thumb': {
      backgroundColor: theme.palette.primary.main,
      borderRadius: 0
    }
  },

  result: {
    borderRadius: '8px',
    minHeight: '52px',
    height: '52px',
    maxHeight: '52px',
    padding: '0',
    fontSize: theme.size.base,
    color: '#3C425B',

    '&:hover': {
      background: '#F5F6F8'
    }
  }
}))

export default useStyles
